module.exports = __webpack_public_path__ + "src/assets/2018/31.jpg";